import { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { LoadingButton } from '@mui/lab';
import { useOfferTermsApi } from '../api';
import { useAlert } from '@lendica/components';

export interface ArchiveDialogProps {
    open: boolean;
    invitationId: string;
    handleClose: () => void;
    onArchived?: () => Promise<void> | void;
}

export const ArchiveDialog = ({
    open,
    invitationId,
    handleClose,
    onArchived,
}: ArchiveDialogProps) => {
    const [loading, setLoading] = useState(false);
    const { setNeutralMessage, setErrorMessage } = useAlert();
    const api = useOfferTermsApi();

    const handleArchive = async () => {
        setLoading(true);
        try {
            if (!invitationId) throw new Error('Invitation ID is required');
            const res = await api.archiveInvitation(invitationId);
            setNeutralMessage(res.message || 'Invitation deleted');

            if (onArchived) {
                await onArchived();
            }
            setTimeout(() => {
                setLoading(false);
                handleClose();
            }, 1500);
        } catch (error: any) {
            setErrorMessage(error.response?.data?.error || error.message);
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
                sx: {
                    paddingY: 1,
                    paddingX: 1,
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to archive this invitation?
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{ whiteSpace: 'pre-line' }}>
                    {`This will remove the invite from the table.`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Cancel
                </Button>
                <LoadingButton
                    loading={loading}
                    onClick={handleArchive}
                    autoFocus
                    variant="contained"
                    color="error"
                >
                    Archive invitation
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};
